import { api } from "../App";
import { SET_VIDEO_CONFIG_LIST, SET_VIDEO_CONFIG_ID, SET_VIDEO_CONFIG_LOADING } from "./types";


export const getVideoConfig = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: true });
    const { data } = await api.get('/xp_video_config');
    dispatch({ type: SET_VIDEO_CONFIG_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: false });
  }
}
export const getVideoConfigId = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: true });
    const { data } = await api.get(`/xp_video_config/${id}`);
    dispatch({ type: SET_VIDEO_CONFIG_ID, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: false });
  }
}

export const createVideoConfig = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: true });
    await api.post('/xp_video_config', data);
    await dispatch(getVideoConfig())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: false });
    return success
  }
}

export const updateVideoConfig = ({ camid, ...data }) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: true });
    await api.put(`/xp_video_config/${camid}`, data);
    await dispatch(getVideoConfig())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: false });
    return success
  }
}

export const deleteVideoConfig = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: true });
    await api.delete(`/xp_video_config/${id}`);
    await dispatch(getVideoConfig())
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_VIDEO_CONFIG_LOADING, payload: false });
  }
}